import { useCallback, useEffect, useRef } from 'react';
import { IAdvertFuseProps } from '../types.js';

export const AdvertDisplayHook = ({ adDisplayTrueCB }: Pick<IAdvertFuseProps, 'adDisplayTrueCB'>): (() => void) => {
  const adDisplayTrueCBRef = useRef(adDisplayTrueCB);

  /** Update AdLogger Ref with props change */
  useEffect(() => {
    adDisplayTrueCBRef.current = adDisplayTrueCB;
  }, [adDisplayTrueCB]);

  const displayAdCB = useCallback(() => adDisplayTrueCBRef.current?.(), []);

  return displayAdCB;
};
